import { FaEnvelope,FaXTwitter} from 'react-icons/fa6';

export default function Footer() {
  return (
    <footer className="footer section">
      <div className="footer__container container grid">
         <div className="footer__content">
          <h3 className="footer__title">Address</h3>
          <ul className="footer__links">
            <li>
                <FaEnvelope/>
             <span>
          
topgunapp@gmaile.com</span>
            </li>
            <li>
              <a
    href="https://wa.me/447572079872"
    target="_blank"
    rel="noopener noreferrer"
    className="text-decoration-none"
  >
    <i className="lni lni-whatsapp"></i>
    <span dir="ltr">+44 7572 079872</span>
  </a>
            </li>
             <div className="footer__social">
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noreferrer"
              className="footer__social-link"
            >
              <i className="ri-facebook-fill" />
            </a>
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noreferrer"
              className="footer__social-link"
            >
              <i className="ri-instagram-line" />
            </a>
            <a
              href="https://twitter.com/"
              target="_blank"
              rel="noreferrer"
              className="footer__social-link"
            >
  <FaXTwitter />            </a>
          </div>
            
          </ul>
        </div>
        <div className="footer__content">
          <h3 className="footer__title">Quick Links</h3>
          <ul className="footer__links">
            <li>
              <a href="#home" className="footer__link">
                Home
              </a>
            </li>
            <li>
              <a href="#specs" className="footer__link">
                Features
              </a>
            </li>
            <li>
              <a href="#how-it-works" className="footer__link">
                How It Works
              </a>
            </li>
            <li>
              <a href="#products" className="footer__link">
                Screenshots
              </a>
            </li>
          </ul>
        </div>

        <div className="footer__content">
          <h3 className="footer__title">Support</h3>
          <ul className="footer__links">
            <li>
              <a href="/" className="footer__link">
                Home
              </a>
            </li>
            <li>
              <a href="/blog" className="footer__link">
Blog              </a>
            </li>
             <li>
              <a href="/about" className="footer__link">
About us              </a>
            </li>
            <li>
              <a href="/privacy" className="footer__link">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="/terms" className="footer__link">
                Terms of Service
              </a>
            </li>
          </ul>
        </div>

        <div className="footer__content">
           <ul>
                  <li>
                   <a href="https://fazier.com/launches/topgun" target="_blank"><img src="https://fazier.com/api/v1/public/badges/embed_image.svg?launch_id=5181&badge_type=monthly&theme=neutral" width="270" alt="Fazier badge" /></a>
                  </li>
                  <li className="my-2 ">
                    <a href="https://fazier.com/launches/topgun" target="_blank"><img src="https://fazier.com/api/v1/public/badges/embed_image.svg?launch_id=5181&badge_type=weekly&theme=neutral" width="270" alt="Fazier badge" /></a>
                  </li>
                  <li>
                  <a href="https://fazier.com/launches/topgun" target="_blank"><img src="https://fazier.com/api/v1/public/badges/embed_image.svg?launch_id=5181&badge_type=daily&theme=neutral" width="270" alt="Fazier badge" /></a>
                  </li>
                </ul>
         
        </div>
      </div>

      <p className="footer__copy">
        © 2025 Topgun. All rights reserved.
        <a
          href=""
          target="_blank"
          rel="noreferrer"
          className="footer__copy-link footer__copy-link--repo"
        />
      </p>
    </footer>
  );
}
